import {handleLogout} from "components/utils";
import React, {forwardRef, useEffect, useRef, useState} from 'react';
import {Button, Form, Modal} from "react-bootstrap";
import axios from "axios";
import {BillView} from "../../inventory/billing/BillView";
import {UpdateDiagnosticServicesTemplateView} from "../UpdateDiagnosticServicesTemplateView";
import Editor from "react-simple-wysiwyg";

export const LabRecordUpdateView = forwardRef((props: { id: string, recordId: any, postAction: any, status: string }, ref) => {

    const [recordId, setRecordId] = useState<string>();
    const [record, setRecord] = useState<any>();
    const [data, setData] = useState<any>();
    const [parameters, setParameters] = useState<Array<any>>([]);
    const [notes, setNotes] = useState<string>();
    const [comments, setComments] = useState<string>();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    let componentRef = useRef(null);

    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const handleCloseUpdateModal = () => setShowUpdateModal(false);
    const handleShowUpdateModal = () => {
        setShowUpdateModal(true)
    }

    function getModalForUpdate() {
        return <Modal
            show={showUpdateModal}
            onHide={handleCloseUpdateModal}
            backdrop="static"
            className="modal-xl"
        >
            <Modal.Header closeButton/>
            <Modal.Body>
                <UpdateDiagnosticServicesTemplateView cookieEntityQr={record && record.entityQr}
                                                      id={data && data.templateId}
                                                      postAction={handleCloseUpdateModal}/>
            </Modal.Body>
        </Modal>
    }


    useEffect(() => {
        if (props.id) {
            fetchRecord()
        }
    }, [props.id])

    useEffect(() => {
        if (props.recordId) {
            setRecordId(props.recordId)
        }
    }, [props.recordId])


    function fetchRecord() {
        axios.get('/api/backend/customer/records/fetch/id/' + props.id)
            .then(resp => {
                setRecord(resp.data)
                setData(JSON.parse(resp.data.data))
                const templateId = JSON.parse(resp.data.data).templateId
                var params = JSON.parse(resp.data.data).parameters
                setComments(JSON.parse(resp.data.data).comments)
                axios.get('/api/backend/templates/param/fetch/all/' + resp.data.entityQr + "/" + templateId)
                    .then(resp => {
                        console.log(JSON.stringify(resp.data))
                        var paramsAvailable = resp.data.filter(p => p.paramType == "VARIABLE")
                        paramsAvailable.forEach(pa => {
                            if (params.filter(p => p.name == pa.name).length <= 0) {
                                params = [...params, {...pa, result: null}]
                            }
                        })
                        setParameters(params)
                        var notes = resp.data.filter(p => p.paramType == "CONSTANT").length > 0 ? resp.data.filter(p => p.paramType == "CONSTANT")[0] : null
                        setNotes(notes.description)
                    })
                    .catch(err => {
                        console.error(err);
                        if (err.response && err.response!.status && err.response!.status === 403) {
                            handleLogout()
                        }
                    })
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                ;
            });
    }


    const handleUpdate = (e) => {
        e.preventDefault();
        setErrorMessage(null)
        setLoading(true)

        axios.post('/api/backend/customer/records/update/record/id/' + recordId, {
            data: {
                category: data.category,
                parameters: parameters,
                notes: notes,
                comments: comments,
                templateId: data.templateId
            }
        })
            .then(resp => {
                console.log(resp.data)
                props.postAction()
            })
            .catch(err => {
                setErrorMessage("Error while creating the record. Please verify the record Id")
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                ;
            }).finally(() => setLoading(false));
    }

    const handleChange = (e, i, value) => {
        e.preventDefault();
        setParameters(oldParams => {
            oldParams[i] = {...data.parameters[i], result: value}
            return oldParams.map(r => r)
        })

    }

    return (
        <>
            {data && <div style={{minHeight: "500px"}}>
                <div className="d-flex gap-2">
                    <strong>Test Name:</strong>
                    <div className="text-decoration-underline mb-3 ml-3">{data.category}</div>
                    {data.templateId && <a href="#/" className="edit ml-4" onClick={handleShowUpdateModal}>✏️ Edit Template</a>}
                </div>
                <div>
                    <table className="table table-borderless">
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Result</th>
                            <th>Unit</th>
                            <th>Bio-reference range</th>
                        </tr>
                        </thead>
                        <tbody>
                        {parameters.map((p, index) => {
                            return <tr key={"para" + index}>
                                <td>{p.name}</td>
                                <td><Form.Control value={parameters[index].result}
                                                  onChange={e => handleChange(e, index, e.target.value)} name="result"
                                                  className="form-control form-control-sm"
                                                  placeholder="Enter Result"/></td>
                                <td>{p.units}</td>
                                <td>{p.bioReference}</td>
                            </tr>
                        })

                        }
                        </tbody>
                    </table>
                    <strong>Comments:</strong>
                    <Editor
                        containerProps={{style: {resize: 'vertical', minHeight: "300px"}}}
                        value={comments}
                        onChange={e => setComments(e.target.value)}
                        placeholder={"Add Comments Here"}
                    />
                    {notes && <div className="mt-2 mb-4">
                        <strong>Notes:</strong>
                        <div dangerouslySetInnerHTML={{__html: notes}} className="border border-dark border-1 pl-2"/>
                    </div>}

                </div>
            </div>}
            <div className="my-2">
                <button className="btn btn-info text-white btn"
                        onClick={e => handleUpdate(e)}>
                    {loading &&
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                            </div>
                        </div>
                    }
                    {!loading && <>Save</>}
                </button>
                {errorMessage &&
                    <div className="text-danger fs-6">*{errorMessage}</div>
                }
            </div>
            {getModalForUpdate()}
        </>

    );
});

LabRecordUpdateView.displayName = "LabRecordUpdateView";